import { distanceUtil } from '../../lib/distanceUtil-sidecar'
import { l } from '../../lib/imports'
import { mathUtils } from '../../lib/mathUtils-sidecar'
import { clickEater } from '../../uiParts/clickEater-sidecar'
import { objs } from '../echo/menuController'
import { voyageCamera } from './voyageCamera-sidecar'
import { voyageColors } from './voyageColors-sidecar'
import { EVoyageCrewType, IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import { voyagePicker } from './voyagePicker-sidecar'
import { voyagePicker_rect } from './voyagePicker_rect-sidecar'
import type { IVoyageUiCanvas } from './voyageUiCanvas'
import { voyageUiCanvas } from './voyageUiCanvas-sidecar'

interface IVoyageUiPickerRect extends IVoyageUiCanvas {
  sx: number
  sy: number
  isDown: boolean
  hasTravelledEnough: boolean
}
let _obj: IVoyageUiPickerRect | null = null
export function get() {
  if (!_obj) {
    _obj = create()
  }
  return _obj
}

export function isRectSelecting() {
  let obj = get()
  return obj.isDown && obj.hasTravelledEnough
}
export function getSelectedInRect(): IVoyageCrew | null {
  let obj = get()

  if (!isRectSelecting()) {
    return null
  }

  let closestCrew: IVoyageCrew | null = null as IVoyageCrew | null
  let closestCrewDistance = 99999

  let mou = voyageCamera.getAdjustedMousePosition()
  let sxy = { x: mathUtils.min(obj.sx, mou.x), y: mathUtils.min(obj.sy, mou.y) }
  let exy = { x: mathUtils.max(obj.sx, mou.x), y: mathUtils.max(obj.sy, mou.y) }
  let cxy = { x: (sxy.x + exy.x) / 2, y: (sxy.y, exy.y) / 2 }

  l.forEach(voyageCrew.getAll(), (c) => {
    let dist = distanceUtil.distanceNormalXY(cxy, c)
    if (dist < closestCrewDistance) {
      // Ensure in rect
      if (c.x < sxy.x) {
        return
      }
      if (c.y < sxy.y) {
        return
      }
      if (c.x > exy.x) {
        return
      }
      if (c.y > exy.y) {
        return
      }
      if (c.type === EVoyageCrewType.Crew) {
        closestCrewDistance = dist
        closestCrew = c
      }
    }
  })

  return closestCrew
}

const create = () => {
  let tw = 0
  let th = 0
  let canvas = voyageUiCanvas.create(tw, th, voyageLayers.getLayers().uiGame)
  canvas.autoOffset = false

  let obj: IVoyageUiPickerRect = voyageUiCanvas.assign<IVoyageUiPickerRect>(
    canvas,
    {
      sx: 0,
      sy: 0,
      isDown: false,
      hasTravelledEnough: false,
    },
  )
  voyageUiCanvas.setOpen(obj, true)
  return obj
}

const render = () => {
  let obj = get()
  let g = obj.graphics

  voyageUiCanvas.clear(obj)
  if (!obj.isDown) {
    return
  }

  let color = voyageColors.yellow

  let uisxy = voyageCamera.getGamePositionToUiPosition(obj.sx, obj.sy)
  let mou = voyageCamera.getUiMousePosition()

  let rw = mou.mx - uisxy.x
  let rh = mou.my - uisxy.y
  if (Math.abs(rw) + Math.abs(rh) > 20) {
    obj.hasTravelledEnough = true
  }

  if (obj.hasTravelledEnough) {
    g.lineStyle(2, color, 1)
    g.strokeRect(uisxy.x, uisxy.y, rw, rh)
    voyageUiCanvas.render(obj)
  }
}

export const update = () => {
  let obj = get()
  voyageUiCanvas.update(obj)

  let mou = voyageCamera.getAdjustedMousePosition()
  if (clickEater.isLeftFirstDownAndUneaten()) {
    obj.hasTravelledEnough = false
    obj.sx = mou.x
    obj.sy = mou.y
    obj.isDown = true
  }
  if (clickEater.isLeftUpRegardless()) {
    if (isRectSelecting()) {
      voyagePicker.get().selectedCrew = getSelectedInRect()
      clickEater.tempEat()
    }
    obj.isDown = false
  }
  // if (clickEater.isLeftFirstUpAndUneaten()) {

  // }

  render()
}
